import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import LogOut from "../MSAL/LoginRedirect";
import { loginRequest } from "../MSAL/authConfig";
import { useMsal } from "@azure/msal-react";
import { callMsGraph } from "../MSAL/graph";

//import { session } from '../functions/SurveyFunction';

//redux
import { useDispatch, useSelector } from 'react-redux'
import { getSesion } from '../store/slices/sesion'
import Load from '../extra/Load'
import { Grid } from '@mui/material';
import Formulario from '../components/formulario';
import { getIngresaTNE } from '../store/slices/ingresaTNE';
import AccesoDenegadoProblemaTI from "../components/AccesoDenegadoProblemaTI"
import AccesoDenegadoFinProceso from "../components/AccesoDenegadoFinProceso"



const PrivateRoutes = () => {
    const { instance, accounts } = useMsal();
    const [load, setLoad] = useState(true)

    //redux
    const dispatch = useDispatch()
    const state = useSelector(state => state.sesion) //se llama al reducer por nombre { name: 'session' }






    useEffect(() => {
        Promise.all([
            dispatch(getSesion(accounts)),
            dispatch(getIngresaTNE()),
        ]).then((response) => {
            console.log("response",response)
        }).finally(() => {
            setLoad(false)
        })

    }, [])


    if (load) {

        return <Load />

    } else {

        // console.log(state.estudiante.data.length > 0)
        const Renderizado = () => (
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                xs={12}
            >
                <Routes>
                    <Route exact path="/" element={<Formulario />} />

                </Routes>
            </Grid>
        )

        const mensajeErrorProblemaTI = () => (
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                xs={12}

            >


                <Grid
                    item
                    xs={12}
                    md={12}

                >



                    <Routes>
                        <Route exact path="/" element={<AccesoDenegadoProblemaTI />} />
                    </Routes>

                </Grid>
            </Grid>
        )


        const mensajeErrorFinProceso = () => (
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                xs={12}

            >


                <Grid
                    item
                    xs={12}
                    md={12}

                >



                    <Routes>
                        <Route exact path="/" element={<AccesoDenegadoFinProceso />} />
                    </Routes>

                </Grid>
            </Grid>
        )

        if(state.estudiante.inicioCierre.length == 0 ) return  mensajeErrorFinProceso()

        return (state.estudiante.data.length > 0 )  ? Renderizado() : mensajeErrorProblemaTI();

    }
};

export default PrivateRoutes